import {makeActionCreator} from '../utility'

export const FETCH_PAYMENTS_REPORTS = 'FETCH_PAYMENTS_REPORTS'
export const fetchPaymentsReport = makeActionCreator(FETCH_PAYMENTS_REPORTS,'data')

export const FETCH_PAYMENTS_REPORTS_SUCCESSFUL = 'FETCH_PAYMENTS_REPORTS_SUCCESSFUL'
export const fetchPaymentsReportSuccessful = makeActionCreator(FETCH_PAYMENTS_REPORTS_SUCCESSFUL, 'data')